export const nonCompliantPatientAction = {
  setReminderHistoryPatient: (state, action) => {
    state.patient = action.payload;
  },
  setReminderHistoryDrawer: (state, action) => {
    const { showDrawer, patient = {} } = action.payload;

    state.showReminderHistoryDrawer = showDrawer;
    state.patient = patient;
  },
  toggleUnenrollModal: (state, action) => {
    const { showModal } = action.payload;

    state.showUnenrollModal = showModal;
  },
  toggleEnrollModal: (state, action) => {
    const { showModal, patient = {} } = action.payload;

    state.showEnrollModal = showModal;
    state.patient = patient;
  },
  toggleDownloadOverduePatientModal: (state, action) => {
    state.showDownloadOverdueModal = action.payload;
  },
  setFilter: (state, action) => {
    const { type, value } = action.payload;
    state[type] = value;
  },
  changeActiveTab: (state, action) => {
    state.activeTab = action.payload;
  },
  setPatientDrawer: (state, action) => {
    const { showDrawer, patient = {} } = action.payload;

    state.showReminderHistoryDrawer = showDrawer;
    state.patient = patient;
  },
};
